import { apiGet, apiPost } from "@/shared/api";

/** Una riga d'ordine di cui OM non sa il costo (o che qualcuno ha scritto a mano). */
export interface RigaCosto {
  sku: string;
  titolo: string;
  quantita: number;
  /** Per pezzo, senza IVA. Il server lo manda come testo; null = nessuno l'ha scritto. */
  costo_netto: number | string | null;
}

export interface RigheSenzaCosto {
  order_id: number;
  reference: string;
  righe: RigaCosto[];
}

const BASE = "/api/costi-manuali";

export const leggiRigheSenzaCosto = (riferimento: string) =>
  apiGet<RigheSenzaCosto>(`${BASE}?ordine=${encodeURIComponent(riferimento)}`);

/** Salva i costi (€ per pezzo, senza IVA); il server ricalcola subito il margine. */
export const salvaCosti = (riferimento: string, costi: Array<{ sku: string; costo: number }>) =>
  apiPost<RigheSenzaCosto>(BASE, {
    ordine: riferimento,
    costi: costi.map((c) => ({ sku: c.sku, costo_netto: c.costo })),
  });
